import React, { useCallback, useState, useEffect, useMemo } from "react";

import OutsideClickHandler from "react-outside-click-handler";

import {
  Container,
  Header,
  LogoAndButtonContainer,
  LinkAndSearchContainer,
  HeaderContent,
  Options,
  OptionsItemsContainer,
  ButtonLogin,
  LogoImage,
  LogoIconMobile,
  SearchIconButton,
} from "./styles";

import MenuInquilino from "./../MenuInquilino/";
import MenuProprietario from "./../MenuProprietario/";

import MenuInquilinoToMobile from "./../MenuInquilinoToMobile/";
import MenuProprietarioMobile from "./../MenuProprietarioToMobile/";

import { useAuth } from "./../../hooks/auth";
import { hasOwnerScopedAccess } from "../../utils/canManageSubLogins";

import logoImg from "./../../assets/components/Header/logo-7cantos.png";

import { Link, useLocation } from "react-router-dom";

import { FiMenu } from "react-icons/fi";
import { MdSearch } from "react-icons/md";
import SearchBarToHeader from "../SearchBarToHeader";
import { isOwnerAreaPath } from "../../utils/isOwnerAreaPath";

interface IHeader {
  hasBorder?: boolean;
  hasSearchBar?: boolean;
  isToShowSearchBarMobile?: boolean;
  hasOptionToSearch?: boolean;
  showAboutUs?: boolean;
  hideLogoMobile?: boolean;
}

export default function HeaderComponent({
  hasBorder,
  hasSearchBar,
  isToShowSearchBarMobile,
  hasOptionToSearch,
  showAboutUs,
  hideLogoMobile = false,
}: IHeader) {
  const { user } = useAuth();

  const { pathname } = useLocation();

  const [showMenu, setShowMenu] = useState(false);
  const [isToCloseClickingInButton, setIsToCloseClickingInButton] =
    useState(false);

  const [showMenuMobile, setShowMenuMobile] = useState(false);

  const [showSearchBar, setShowSearchBar] = useState(isToShowSearchBarMobile);

  const shouldHideLogoMobile = hideLogoMobile || !!hasSearchBar;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const handleShowMenu = useCallback(() => {
    setIsToCloseClickingInButton(true);

    setShowMenu(true);
  }, []);

  const handleCloseMenu = useCallback(() => {
    setIsToCloseClickingInButton(true);
    setShowMenu(false);
  }, []);

  const handleCloseMenuClickingOutside = useCallback(() => {
    setIsToCloseClickingInButton(false);
    setShowMenu(false);
  }, []);

  const handleShowMenuMobile = useCallback(() => {
    setShowMenuMobile(true);
  }, []);

  const handleCloseMenuMobile = useCallback(() => {
    setShowMenuMobile(false);
  }, []);

  const usernameFormated = useMemo(() => {
    if (!!user) {
      if (/\s/.test(user.first_name)) {
        const index = user.first_name.indexOf(" ");
        const usernameFormated = user.first_name.substr(0, index);
        return `${usernameFormated}`;
      }
      return user.first_name;
    }
  }, [user]);

  const isAdminUser = useMemo(() => {
    if (!user) {
      return false;
    }

    return (
      user.type === "admin" ||
      user.role === "admin" ||
      user.is_admin === true ||
      user.isAdmin === true
    );
  }, [user]);

  const isOwnerArea = isOwnerAreaPath(pathname);
  const showOwnerMenu = useMemo(() => hasOwnerScopedAccess(user), [user]);

  return (
    <Container $isDark={isOwnerArea}>
      <Header hasBorder={!!hasBorder} $isDark={isOwnerArea}>
        <HeaderContent>
          <LinkAndSearchContainer
            isToDisapear={showSearchBar}
            hideLogoMobile={shouldHideLogoMobile}
          >
            <LogoAndButtonContainer
              isToShowSearchBarMobile={isToShowSearchBarMobile || showSearchBar}
              hideLogoMobile={shouldHideLogoMobile}
            >
              <Link to="/">
                <LogoImage
                  src={logoImg}
                  alt="logo"
                  hideLogoMobile={shouldHideLogoMobile}
                />
              </Link>

              <button onClick={handleShowMenuMobile}>
                <FiMenu size={30} color="#DD6435" />
              </button>
            </LogoAndButtonContainer>

            {!!hasSearchBar && (
              <SearchBarToHeader
                hasSearchBar={hasSearchBar}
                isToShowSearchBarMobile={isToShowSearchBarMobile}
                showSearchBar={showSearchBar}
                isDark={isOwnerArea}
              />
            )}

            {!!hasOptionToSearch && (
              <SearchIconButton
                $isDark={isOwnerArea}
                onClick={() => setShowSearchBar(true)}
                aria-label="Abrir busca"
              >
                <MdSearch size={20} />
                <span>Pesquisar</span>
              </SearchIconButton>
            )}
            <Options
              hasSearchBar={hasSearchBar}
              hideLogoMobile={shouldHideLogoMobile}
            >
              <OptionsItemsContainer $isDark={isOwnerArea}>
                <Link to="/advertise-property" target="_blank">
                  Anunciar Imóvel
                </Link>
                <Link to="/indicar-imovel">Indique & Ganhe</Link>
                {!!showAboutUs && <Link to="/about-us">Sobre nós</Link>}
                {isAdminUser && <Link to="/style-guide">Guia de estilo</Link>}
              </OptionsItemsContainer>
            </Options>

            {shouldHideLogoMobile && (
              <LogoIconMobile className="logo-mobile">
                <Link to="/">
                  <img src="/favicon.png" alt="logo" />
                </Link>
              </LogoIconMobile>
            )}
          </LinkAndSearchContainer>

          <ButtonLogin $isDark={isOwnerArea}>
            {!!user === false && (
              <Link
                id="button-link"
                to={{
                  pathname: "/login",
                  state: { fromSite: true },
                }}
              >
                Entrar
              </Link>
            )}
            <p
              style={user ? { visibility: "visible" } : { display: "none" }}
            >{`Olá, ${usernameFormated}`}</p>
            <button
              onClick={
                !!isToCloseClickingInButton
                  ? handleCloseMenuClickingOutside
                  : handleShowMenu
              }
            >
              <FiMenu size={24} color="#DD6435" />
            </button>
          </ButtonLogin>
        </HeaderContent>

        {showMenu === true && (
          <>
            {!!user && (
              <div>
                {showOwnerMenu ? (
                  <OutsideClickHandler onOutsideClick={handleCloseMenu}>
                    <MenuProprietario />
                  </OutsideClickHandler>
                ) : (
                  <OutsideClickHandler onOutsideClick={handleCloseMenu}>
                    <MenuInquilino />
                  </OutsideClickHandler>
                )}
              </div>
            )}

            {!!user === false && (
              <OutsideClickHandler onOutsideClick={handleCloseMenu}>
                <MenuInquilino />
              </OutsideClickHandler>
            )}
          </>
        )}

        {!!showMenuMobile && (
          <>
            {!!user && (
              <div>
                {showOwnerMenu ? (
                  <MenuProprietarioMobile
                    functionToCloseMenuProprietarioToMobile={
                      handleCloseMenuMobile
                    }
                  />
                ) : (
                  <MenuInquilinoToMobile
                    functionToCloseMenuInquilinoToMobile={handleCloseMenuMobile}
                  />
                )}
              </div>
            )}

            {!!user === false && (
              <MenuInquilinoToMobile
                functionToCloseMenuInquilinoToMobile={handleCloseMenuMobile}
              />
            )}
          </>
        )}
      </Header>
    </Container>
  );
}
